export const constObj = {
  generalFeedbackSuccess: "Feedback submitted",
  generalFeedbacemailFail: "Unable to submit feedback",
  annotationAddedSuccessMessage: "Annotation added",
  annotationEditedSuccessMessage: "Annotation edited",
  userAddedSuccessMessage: "User added",
  userEditedSuccessMessage: "User modified",
  annotationAddedFailMessage: "Unable to add annotation",
  annotationEditedFailMessage: "Unable to edit annotation",
  userAddedFailMessage: "Unable to add user",
  userEditedFailMessage: "Unable to modify user",
  annotationDeletionConfirmationPromptMessage: "Are you sure you want to delete this annotation?",
  annotationRemovedSuccessMessage: "Annotation removed",
  userDeletionConfirmationPromptMessage: "Are you sure you want to delete this user?",
  annotationRemovedFailMessage: "Unable to remove annotation",
  userRemovedSuccessMessage: "User removed",
  linkSharedMessage: "Link copied to clipboard",
  userRemovedFailMessage: "Unable to remove user",
  bookmarkAddedMessage: "Bookmark added",
  bookmarkAddedFailMessage: "Unable to add bookmark",
  bookmarkRemovedMessage: "Bookmark removed",
  deleteAllPrintQueue: "Are you sure you want to delete queue for all selected paragraphs?",
  loginvalidationError: "Login failed: Invalid username or password.Please verify your credentials and try again.If that does not work, please contact",
  loginCaptchaError: "Please complete the reCaptcha and resubmit the form.",
  contactSupportSuccess: "Your feedback was successfully sent.",
  Norecords: "No records found",
  EarlyAdoption: "Early Adoptions",
  SpecialCases: "Special Cases",
  GenerateReportPrintMessage:"Please generate a report first",
  AdminErrorMessage: "The following users are currently logged In:",
  microserviceFailureOnContentPage: "Unable to load annotation/bookmark. Please try again after some time.",
  microserviceFailureOnHomePage: "Unable to load my history/my bookmark. Please try again after some time.",
  microserviceFailureOnMyAnnotation: "Unable to load my annotation. Please try again after some time.",
  microserviceFailureOnMyBookmark: "Unable to load my bookmark. Please try again after some time.",
  microserviceFailureOnMyHistory: "Unable to load my history. Please try again after some time.",
  secDefinition: "SEC Definition",
  notAvailableForBAsic: "Information is available at ",
  microserviceFailureOnAccessManagement: "Unable to load users. Please try again after some time.",
  glossaryTermClickForBasic: "The Glossary Term Usage Page is Disabled for the Basic View",
  aaaFeaturemessage: "For more information regarding your AAA account, please go to <br/> <a class='mr-12-5rem' target='_blank' href='https://aaahq.org/Research/FASB-GARS'>https://aaahq.org/Research/FASB-GARS</a>",
  passwordReset: "Your password has been reset. Please log in again.",
  annotationAlertPrintQueue: "If you leave this page, your print queue will be cleared.<br> Do you want to continue?",
  adminDetailsUpdate: "Your account details have been updated. Please log in again.",
  xbrlDataLoadFailure: "Unable to load XBRL information. Please try again after some time.",
  redisCacheClearMessage: "Redis cache cleared for ",
  redisCacheClearFailedMessage: "Unable to clear Redis cache. Please try again.",
  redisCacheClearConfirmationMessage: "Are you sure you want to clear the cache for the <b>{SITENAME}</b> application?"
};


